import apiClient from './shared/services/apiClient';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { clearLegacyIdCache } from './shared/utils/cacheMigration';

apiClient.defaults.withCredentials = true;
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/css/nucleo-icons.css';
import './assets/css/nucleo-svg.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAnalytics } from './shared/analytics';

// One-time cache migration: Clear legacy integer IDs from browser storage
// This runs once on app load after the frontend GUID migration (spec 009)
if (!localStorage.getItem('guidMigrationCleared')) {
  clearLegacyIdCache();
}

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
